import { useSelector } from 'react-redux';

import _ from 'lodash';

export const useStoreGetSelector = (path, defaultValue) => {
  const selectorFunction = (state) => _.get(state, path, defaultValue);

  return useSelector(selectorFunction, _.isEqual);
};
